import { Component } from '@angular/core';

import {NavController, NavParams} from 'ionic-angular';

import { AboutPage } from '../about/about';
import { TestPage } from '../test/test';
import { MapPage } from '../map/map';
import { SchedulePage } from '../schedule/schedule';
import { SpeakerListPage } from '../speaker-list/speaker-list';
import {UserData} from "../../providers/user-data";


@Component({
  templateUrl: 'tabs-page.html'
})
export class TabsPage {
  // set the root pages for each tab
  tab1Root: any = SchedulePage;
  tab2Root: any = SpeakerListPage;
  tab3Root: any = MapPage;
  tab4Root: any = AboutPage;
  tab5Root: any = TestPage;
  mySelectedIndex: number;

  constructor(
      navParams: NavParams,
      public navCtrl: NavController,
      public user: UserData
  ) {
    this.mySelectedIndex = navParams.data.tabIndex || 0;
  }
  ionViewWillEnter() {
    this.user.checkLoggedIn(this.navCtrl,'SchedulePage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs-page/tabs-page.ts